import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MOODS } from 'app/shared/models/clock-out-mood.model';
import { MoodEnum } from 'app/utils/enums/timesheet.enum';
import { WebcamImage } from 'ngx-webcam';

@Component({
  selector: 'app-clock-out-dialog',
  templateUrl: './clock-out-dialog.component.html',
  styleUrls: ['./clock-out-dialog.component.scss'],
  standalone: false,
})
export class ClockOutDialogComponent {
  moods = MOODS;
  selectedMood: MoodEnum | null = null;
  hasBreak: Boolean = false;
  note: string = '';

  constructor(
    public dialogRef: MatDialogRef<ClockOutDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { webcamImage: WebcamImage | null; fileName: string },
  ) {}

  ngOnInit(): void {}

  onHandleCloseDialog() {
    this.dialogRef.close({
      hasBreak: this.hasBreak,
      mood: this.selectedMood,
      note: this.note,
    });
  }

  isMoodSelected(mood: MoodEnum): boolean {
    return this.selectedMood === mood;
  }

  selectMood(mood: MoodEnum): void {
    this.selectedMood = this.selectedMood === mood ? null : mood;
  }
}
